import { createContext } from "react";

export default createContext({
  getIconSrc: (name) => void name,
});
